import { render } from "./UpdateOfferingAccess.vue?vue&type=template&id=6464ce2e&scoped=true"
import script from "./UpdateOfferingAccess.vue?vue&type=script&lang=js"
export * from "./UpdateOfferingAccess.vue?vue&type=script&lang=js"

import "./UpdateOfferingAccess.vue?vue&type=style&index=0&id=6464ce2e&scoped=true&lang=scss"

import exportComponent from "/build/cloudstack/dist/rpmbuild/BUILD/cloudstack-4.18.1.0/ui/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6464ce2e"]])

export default __exports__